module.exports = __webpack_public_path__ + "static/media/fire_robe.aeff41f6.png";